import { apiGet, apiPost, apiPatch } from 'lib/apiClient'

// -------- settings_org ----------
export async function getOrgSettings() {
  const { data, error } = await apiGet('/settings/org/');
  if (error && !error.includes('404')) throw new Error(error);
  return data || { id: 1, org_name: '', inn: '', address: '', phone: '', director_name: '', logo_url: '' };
}

export async function upsertOrgSettings(payload) {
  const { data, error } = await apiPost('/settings/org/', payload);
  if (error) throw new Error(error);
  return data;
}

// -------- settings_numbering ----------
export async function listNumbering() {
  const { data, error } = await apiGet('/settings/numbering/');
  if (error) throw new Error(error);
  return data || [];
}

export async function updateNumbering(id, patch) {
  const { data, error } = await apiPatch(`/settings/numbering/${id}/`, patch);
  if (error) throw new Error(error);
  return data;
}
